export const isMacOs = (): boolean => {
  if (typeof navigator === "undefined") return false;
  return navigator?.userAgent?.includes("Mac") ?? false;
};

export const getControlKey = (): string => {
  return isMacOs() ? "⌘" : "Ctrl";
};

/**
 * Check if the OS-appropriate modifier key is pressed
 * - CMD (metaKey) on Mac
 * - CTRL (ctrlKey) on Windows/Linux
 */
export const isModifierKeyPressed = (
  e: React.PointerEvent | React.KeyboardEvent | React.MouseEvent
): boolean => {
  return isMacOs() ? e.metaKey : e.ctrlKey;
};
